import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-charcoal text-[#FBEFD9] pt-16 pb-6 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#7A1F1F]/40 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10 relative">
        <div>
          <div className="flex items-center gap-3">
            <img src="/images/logo_new.png" alt="Puri Puri" className="h-14 object-contain" />
          </div>
          <p className="mt-4 text-[#FBEFD9]/70 text-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="font-display text-[#D4A94A] tracking-widest text-sm uppercase">{t.footer.contact}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#E86D1F] mt-0.5 shrink-0" />
              <span>{restaurantInfo.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#E86D1F] shrink-0" />
              <a href={`tel:${restaurantInfo.phoneClean}`} className="hover:text-[#D4A94A] transition-colors">{restaurantInfo.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#E86D1F] shrink-0" />
              <a href={`mailto:${restaurantInfo.email}`} className="hover:text-[#D4A94A] transition-colors">{restaurantInfo.email}</a>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-display text-[#D4A94A] tracking-widest text-sm uppercase">{t.footer.hours}</p>
          <ul className="mt-5 space-y-2 text-sm">
            {t.contact.days.map((h, i) => (
              <li key={i} className="flex justify-between border-b border-[#D4A94A]/10 pb-2">
                <span className="text-[#D4A94A]">{h.day}</span>
                <span className="text-[#FBEFD9]/80">{h.time}</span>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex gap-3">
            <a href="#" onClick={(e)=>e.preventDefault()} className="w-10 h-10 rounded-full border border-[#D4A94A]/40 flex items-center justify-center hover:border-[#E86D1F] hover:text-[#E86D1F] transition">
              <Facebook size={16} />
            </a>
            <a href="#" onClick={(e)=>e.preventDefault()} className="w-10 h-10 rounded-full border border-[#D4A94A]/40 flex items-center justify-center hover:border-[#E86D1F] hover:text-[#E86D1F] transition">
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-[#D4A94A]/15 text-center text-xs text-[#FBEFD9]/50">
        © {new Date().getFullYear()} {t.footer.copyright}
      </div>
    </footer>
  );
}
